<template>
    <div id="addAttachmentsModal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title h5" id="addAttachmentsTitle">Add Attachments</div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>                        
                </div>
                <div class="modal-body d-flex align-items-stretch p-0">
                    <div class="font-weight-bold border-right sections">
                            <div v-for="section in sections" :key="section" class="list-group list-group-flush" id="list-tab" role="tablist">
                                <a v-if="attachments && attachments[section].length"
                                    :class="['list-group-item list-group-item-action text-capitalize', { 'active': section === selectedSection }]" 
                                    :id="'list-' + section + '-list'" 
                                    data-toggle="list" 
                                    :href="'#list-' + section" 
                                    role="tab"
                                    @click="selectedSection = section">{{ section }}</a>
                            </div>
                    </div>
                    <div v-if="attachments && attachments[selectedSection].length" class="container-fluid">
                        <div class="d-flex align-items-end border-bottom py-2">                            
                            <div class="input-group input-group-sm ml-auto">
                                <div class="input-group-prepend">
                                    <div class="input-group-text"><i class="fas fa-search fa-sm text-muted"></i></div>
                                </div>
                                <input type="text" class="form-control" placeholder="Search Descriptions" v-model="searchString">
                            </div>
                        </div>
                        <div class="table-container">
                            <table class="table table-sm border-none-top table-font-size px-0 mt-2">
                                <thead>
                                    <tr>
                                        <th class="fit"></th>
                                        <th class="fit">Document Type</th>
                                        <th>Description</th>
                                        <th class="fit">Owner</th>
                                        <th class="fit">Uploaded</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="attachment in filteredAttachments" :key="attachment.id">
                                        <td class="fit">
                                            <div class="custom-control custom-checkbox">
                                                <input :id="'attachment-checkbox-' + attachment.id" type="checkbox" class="custom-control-input" v-model="attachment.selected">
                                                <label class="custom-control-label align-top" :for="'attachment-checkbox-' + attachment.id">
                                                    <span class="sr-only"></span>
                                                </label>
                                            </div>
                                        </td>
                                        <td class="fit">
                                            <document-status-icon v-if="attachment.document_status" :document-id="attachment.id" :document-status="attachment.document_status"></document-status-icon>
                                            {{ attachment.document_type.name }}
                                        </td>
                                        <td :title="attachment.description">{{ attachment.description | truncate(30) }}</td>
                                        <td class="fit">{{ attachment.owner }}</td>
                                        <td class="fit">{{ attachment.created_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div v-else class="flex-fill text-center">
                        <h3 class="text-muted mt-3">No Documents Available</h3>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-primary" @click="attach()" :disabled="!(selectedDocuments && selectedDocuments.length)">Attach</button>
                    <button class="btn btn-secondary" data-dismiss="modal">Cancel</button>                  
                </div>                                       
            </div>
        </div>
    </div>
</template>

<script>
import { DocumentType } from '../../constants.js';
import DocumentStatusIcon from '../documents/DocumentStatusIconComponent.vue';

export default {
    components: {
        DocumentStatusIcon
    },
    props: {
        claimId: Number
    },
    data() {
        return {
            // import constants into the template
            DocumentType: DocumentType,

            documentTypeId: null,
            documentIds: [],            // these are the ids of the documents we are submitting
            attachments: null,
            sections: [],
            selectedSection: 'others',
            callback: null,
            event: null,
            searchString: '',
            preselected: [],
            documentId: null              // this is only used when showing attachments from the response reply modal
                                          // this is the id of the document we are replying to
        }
    },
    computed: {
        sectionDocuments: function () {
            return this.attachments[this.selectedSection];
        },
        filteredAttachments: function () {
            const self = this;
            return self.attachments[this.selectedSection].filter(e => (e.description.toLowerCase().indexOf(self.searchString.toLowerCase()) !== -1));
        },
        selectedDocuments: function () {
            let retval = [];
            this.sections.forEach(section => {
                retval = retval.concat(this.attachments[section]);
            });

            return retval.filter(e => e.selected);
        }
    },    
    methods: {
        show: function (documentTypeId, preselected, callback, event, documentId = null) {
            const self = this;
            this.documentTypeId = documentTypeId;
            this.preselected = preselected; 
            this.callback = callback;
            this.event = event; 
            this.documentId = documentId;

            let href = documentId ? 
                ('/ajax/claims/' + this.claimId + '/responses/' + documentId + '/attachable-documents') :
                ('/ajax/claims/' + this.claimId + '/document-types/' + documentTypeId + '/attachable-documents');

            axios.get(href)
                .then(response => {
                    this.attachments = response.data;
                    this.sections = Object.keys(this.attachments);

                    this.sections.forEach(x => {
                        this.attachments[x] = this.attachments[x].map(e => {
                            let isSelected = this.preselected.includes(e.id);
                            this.$set(e, 'selected', isSelected);
                            return e;
                        });
                    });

                    switch(this.documentTypeId) {
                        case DocumentType.LWC_FORM_1010:
                        case DocumentType.CMS_1500:
                        case DocumentType.CMS_1450:
                            this.selectedSection = 'others';
                            break;
                        case DocumentType.LWC_FORM_1009:
                            this.selectedSection = this.attachments['authorizations'].length ? 'authorizations' : 'others';
                            break;
                        case DocumentType.LWC_FORM_1010A:
                            this.selectedSection = this.attachments['responses'].length ? 'responses' : 'others';
                            break;
                    }                

                    $('#addAttachmentsModal').modal('show');
                })
                .catch(error => {
                    console.error(error);
                });            
        },
        attach: function () {
            this.callback(this.selectedDocuments);
            $('#addAttachmentsModal').modal('hide');
        }
    },
    mounted() {

        // add hide event handler
        const self = this;
        $('#addAttachmentsModal').on('hide.bs.modal', function(e) {
            eventHub.$emit(self.event);
        }); 
    },  
    created() {
        eventHub.$on('show-add-attachments', this.show);        
    },
    beforeDestroy() {
        eventHub.$off('show-add-attachments');
    }     
}
</script>

<style scoped>

    #addAttachmentsModal {
        z-index: 9999;
    }

    #addAttachmentsModal .modal-content {
        min-height: 500px;
    }

    .border-none-top th {
        border-top: none;
    }

    .table-container {
        height: 75vh;
        overflow: auto;
    }

    .table-font-size {
        font-size: .85rem;
    }

    .sections {
        width: 200px;
    }      
</style>